import React from 'react'
import { Container, Paper, Typography, Button, Box } from '@mui/material'
import { Lock as LockIcon } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'

export const UnauthorizedPage: React.FC = () => {
  const navigate = useNavigate()

  return (
    <Container component="main" maxWidth="sm">
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Paper
          elevation={3}
          sx={{
            padding: 4,
            textAlign: 'center',
            width: '100%',
          }}
        >
          <LockIcon sx={{ fontSize: 64, color: 'text.secondary', mb: 2 }} />

          <Typography variant="h4" component="h1" gutterBottom>
            アクセス権限がありません
          </Typography>

          <Typography variant="body1" color="text.secondary" paragraph>
            このページにアクセスする権限がありません。
            適切な権限をお持ちでない場合は、管理者にお問い合わせください。
          </Typography>

          <Button variant="contained" onClick={() => navigate('/dashboard')} sx={{ mt: 2 }}>
            ダッシュボードに戻る
          </Button>
        </Paper>
      </Box>
    </Container>
  )
}
